import { z } from "zod/v4";

export const GetCampaignFunctionCountResponseBodySchema = z.object({
  count: z.number(),
});
export type GetCampaignFunctionCountResponseBodyType = z.infer<
  typeof GetCampaignFunctionCountResponseBodySchema
>;
